import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isExist } from "cxa-utils";
import { InputField } from "../../FormField";

const Policy = ({ data }) => {
  const policyNumber = data["PolicyNumber"] || {};
  const effectiveDate = data["EffectiveDate"] || {};
  const companyName = data["CompanyName"] || {};

  return (
    <fieldset>
      <h3>POLICY INFORMATION</h3>
      <section className="basicinfo">
        <div style={{ width: 300 }}>
          <label htmlFor="PolicyNumber">Policy Number</label>
          <div className="field-container" id="RO_PolicyNumber">
            <InputField name="PolicyNumber" {...policyNumber} />
          </div>
        </div>
        <div className="alignright" style={{ width: 300 }}>
          <label htmlFor="EffectiveDate">{"Insured's Effective date"}</label>
          <div className="field-container" id="RO_EffectiveDate">
            <InputField
              name="EffectiveDate"
              format={value => isExist(value) && moment(value).format()}
              {...effectiveDate}
            />
          </div>
        </div>
        <div>
          <label htmlFor="CompanyName">Name of Company</label>
          <div className="field-container" id="RO_CompanyName">
            <InputField name="CompanyName" {...companyName} />
          </div>
        </div>
      </section>
    </fieldset>
  );
};

Policy.propTypes = {
  data: PropTypes.object,
};

export default Policy;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/Policy.js